import { useMemo } from 'react';

import { EMPTY_ARRAY } from '../../../constants';

interface OptionsFilterProps<T> {
  options: T[];
  option_key: keyof T;
  typed_value: string | number;
  reset_filter: boolean;
}

export const useOptionsFilter = <T extends Record<string, any>>({
  options = EMPTY_ARRAY,
  option_key,
  typed_value = '',
  reset_filter,
}: OptionsFilterProps<T>): T[] => {
  return useMemo(() => {
    if (reset_filter || !typed_value) {
      return options;
    }

    const search = String(typed_value).toLowerCase().trim();

    return options.filter((option) => {
      const value = option[option_key];
      if (value == null) return false;

      const string = String(value).toLowerCase();

      if (string === search) return true;

      if (string.startsWith(search)) return true;

      if (string.includes(search)) return true;

      const words = string.split(/\s+/);
      return words.some((word) => word.startsWith(search));
    });
  }, [options, option_key, typed_value, reset_filter]);
};
